import React from "react";
import { motion } from "framer-motion";
import { Flame, Stethoscope, Brain, Check } from "lucide-react";
import { SERVICES } from "../content";

const ICONS = { flame: Flame, stethoscope: Stethoscope, brain: Brain };

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative section-pad"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl"
        >
          <div className="text-[#27C6FF] uppercase tracking-[0.3em] text-xs mb-5 font-heading">
            Services
          </div>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.05]">
            Built for your goal,
            <br />
            <span className="gradient-text">tuned to your body.</span>
          </h2>
        </motion.div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || Flame;
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                whileHover={{ y: -6 }}
                className="relative glass gradient-border rounded-3xl p-7 group transition-all duration-500"
                data-testid={`service-card-${s.title.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#7A2BFF] to-[#27C6FF] flex items-center justify-center mb-6 shadow-[0_0_30px_rgba(122,43,255,0.45)] group-hover:rotate-6 transition-transform duration-500">
                  <Icon size={24} className="text-white" />
                </div>
                <h3 className="font-display font-bold text-2xl text-white">
                  {s.title}
                </h3>
                <p className="mt-3 text-[#D8CCFF] text-sm md:text-base leading-relaxed font-body">
                  {s.desc}
                </p>

                <ul className="mt-6 space-y-3">
                  {s.benefits.map((b) => (
                    <li
                      key={b}
                      className="flex items-start gap-3 text-sm text-[#CFAEFF]"
                    >
                      <span className="mt-0.5 w-5 h-5 rounded-full bg-[#27C6FF]/15 border border-[#27C6FF]/40 flex items-center justify-center flex-shrink-0">
                        <Check size={12} className="text-[#27C6FF]" />
                      </span>
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>

                <a
                  href="#booking"
                  data-testid={`service-cta-${s.title.toLowerCase().replace(/\s+/g, "-")}`}
                  className="mt-8 inline-flex items-center gap-2 text-sm font-heading font-semibold text-white border-b border-[#27C6FF]/40 hover:text-[#27C6FF] transition-colors"
                >
                  Explore programme →
                </a>

                <div className="absolute -top-12 -right-12 w-40 h-40 bg-[#27C6FF]/15 blur-3xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
